<section *ngIf="messageService.messages.length" class="messageBox ms-font-m">
	<h5 class="mHeader">
		<span class="mHeader_title ms-font-xl ms-fontWeight-regular">Mensajes</span>
		<button class="clear mHeader_btn ms-font-xs" (click)="messageService.clear()">Limpiar</button>
	</h5>
	<ul class="message">
		<li class="message_item" *ngFor='let message of messageService.messages'> {{message}} </li>
	</ul>
</section>